export default __webpack_public_path__ + "static/media/BNB.a82db22c.png";